<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import notify from "../../../../Script/notify"

  export let confirmPasscode = ""
  export let passcode = ""

  /**
   * @type {Boolean} whether to show passcode enter area are not
   */
  let toggleBtn = false

  /**
   * @type {HTMLElement} passcode enter input element
   */
  let passcodeElem

  /**
   * @type {HTMLElement} confirm passcode enter input element
   */
  let confirmPasscodeElem

  /**
   * @type {passcodeNotify}
   */
  let passcodeNotify = {
    close() {},
  }

  /**
   * @description function for dispatch the confirm passcode.
   */
  const setPasscode = () => {
    // if (passcode == confirmPasscode && passcode.length >= 5 && confirmPasscode.length >= 5) {
    //   passcodeNotify.close()
    //   // passcodeNotify = notify.success("passcode set successfully")
    // }
    dispatch("output", confirmPasscode)
  }
</script>

<div class="group space-y-3">
  <button on:click={() => (toggleBtn = !toggleBtn)} class="flex w-full items-center justify-between {passcode == confirmPasscode && passcode.length >= 5 && confirmPasscode.length >= 5 ? 'bg-green-500' : toggleBtn ? 'bg-[#09f6e7]/50' : 'bg-slate-200 hover:bg-[#09f6e7]/50 dark:bg-[#212539] dark:hover:bg-[#09f6e7]/50'} rounded-md px-3 py-2 text-[#292a23] dark:text-[#09f6e7] sm:px-6 sm:py-4">
    <div class="flex select-none {(passcode == confirmPasscode && passcode.length >= 5 && confirmPasscode.length >= 5) || toggleBtn ? 'text-white' : ''} items-center gap-3 text-sm font-semibold group-hover:text-white mobile:text-base">
      <i class="fa-solid fa-eye hidden mobile:block" />
      <p>Secure by passcode</p>
    </div>
    <div class="flex items-center gap-3">
      {#if passcode == confirmPasscode && passcode.length >= 5 && confirmPasscode.length >= 5}
        <div class="text-base text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-check" />
        </div>
      {:else}
        <div class="text-base {toggleBtn ? 'text-white' : 'text-[#292a2f] dark:text-[#09f6e7]'} group-hover:text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-exclamation" />
        </div>
      {/if}
      <!-- <ToggleSwitch bind:toggleBtn disable={passcode === confirmPasscode && passcode.length >= 5 && confirmPasscode.length >= 5} /> -->
    </div>
  </button>
  {#if toggleBtn}
    <div class="space-y-3 rounded-md p-3 shadow-md dark:bg-bodyblack mobile:p-6">
      <p class="select-none text-justify text-gray-800 dark:text-gray-200">Here you can secure the document by passcode. Give minimum 5 characters</p>
      <form on:submit|preventDefault|stopPropagation={setPasscode} class="space-y-3">
        <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-6">
          <p class="w-full select-none text-sm text-gray-200 sm:w-4/12 sm:text-base">Passcode</p>
          <div class="w-full">
            <div class="relative w-full sm:w-2/3">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  if (passcodeElem.type == "password") passcodeElem.type = "text"
                  else passcodeElem.type = "password"
                }}
                class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center hover:text-blue-500 active:text-blue-400 disabled:cursor-not-allowed dark:text-gray-200 dark:hover:text-blue-500 dark:active:text-blue-400"
              >
                <span>
                  <i class="fa-solid {passcodeElem && passcodeElem.type == 'password' ? 'fa-eye' : 'fa-eye-slash'} " />
                </span>
                <!-- <i class="fa-solid "></i> -->
              </div>
              <input
                bind:this={passcodeElem}
                bind:value={passcode}
                on:input={(e) => {
                  if (e.target.value.length > 20) {
                    passcodeNotify.close()
                    //returning values only in range below max characters using slice method after a delay of 20ms
                    passcode = e.target.value.slice(0, 21)
                    //Throw notification for exceeding max Characters
                    passcodeNotify = notify.info(`Cannot enter more than 20 characters`)
                  }
                  setPasscode()
                }}
                placeholder="xxxxxx"
                type="password"
                name="passcode"
                class="h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-6">
          <p class="w-full select-none text-sm text-gray-200 sm:w-4/12 sm:text-base">Confirm Passcode</p>
          <div class="w-full">
            <div class="relative w-full sm:w-2/3">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  if (confirmPasscodeElem.type == "password") confirmPasscodeElem.type = "text"
                  else confirmPasscodeElem.type = "password"
                }}
                class="absolute inset-y-0 right-0 flex aspect-square cursor-pointer items-center justify-center hover:text-blue-500 active:text-blue-400 disabled:cursor-not-allowed dark:text-gray-200 dark:hover:text-blue-500 dark:active:text-blue-400"
              >
                <i class="fa-solid {confirmPasscodeElem && confirmPasscodeElem.type == 'password' ? 'fa-eye' : 'fa-eye-slash'}" />
              </div>
              <input
                bind:this={confirmPasscodeElem}
                bind:value={confirmPasscode}
                on:input={(e) => {
                  if (e.target.value.length > 20) {
                    passcodeNotify.close()
                    //returning values only in range below max characters using slice method after a delay of 20ms
                    confirmPasscode = e.target.value.slice(0, 21)
                    //Throw notification for exceeding max Characters
                    passcodeNotify = notify.info(`Cannot enter more than 20 characters`)
                  }
                  setPasscode()
                }}
                placeholder="xxxxxx"
                type="password"
                name="confirm_passcode"
                class="h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  {/if}
</div>
